import { c as _c } from "react/compiler-runtime";
// Avatar component for displaying user initials or images
import { type VariantProps } from "tailwind-variants";
import React from "react";
import { FaUser } from "react-icons/fa";
import { tv } from "@/lib/tailwind-utils";
import { cx } from "@/lib/tailwind-utils";
const avatarVariants = tv({
  base: cx("inline-flex items-center justify-center rounded-full font-medium ring-1 ring-inset"),
  variants: {
    size: {
      sm: "h-6 w-6 text-caption",
      md: "h-8 w-8 text-body",
      lg: "h-10 w-10 text-body-lg",
      xl: "h-12 w-12 text-lg"
    },
    variant: {
      default: ["bg-accent text-accent-foreground ring-primary/30"],
      neutral: ["bg-background-tertiary text-foreground-secondary ring-border"],
      primary: ["bg-primary text-primary-foreground ring-primary"],
      secondary: ["bg-muted text-muted-foreground ring-border-secondary"]
    }
  },
  defaultVariants: {
    size: "md",
    variant: "default"
  }
});
interface AvatarProps extends React.ComponentPropsWithoutRef<"div">, VariantProps<typeof avatarVariants> {
  src?: string;
  alt?: string;
  fallback?: string;
}
const Avatar = React.forwardRef<HTMLDivElement, AvatarProps>((t0, forwardedRef) => {
  const $ = _c(23);
  let alt;
  let className;
  let fallback;
  let props;
  let size;
  let src;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      size,
      variant,
      src,
      alt,
      fallback,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = alt;
    $[2] = className;
    $[3] = fallback;
    $[4] = props;
    $[5] = size;
    $[6] = src;
    $[7] = variant;
  } else {
    alt = $[1];
    className = $[2];
    fallback = $[3];
    props = $[4];
    size = $[5];
    src = $[6];
    variant = $[7];
  }
  const getInitials = _temp2;
  const displayFallback = fallback || "U";
  const [failedSrc, setFailedSrc] = React.useState();
  let t1;
  if ($[8] !== className || $[9] !== size || $[10] !== variant) {
    t1 = cx(avatarVariants({
      size,
      variant
    }), className);
    $[8] = className;
    $[9] = size;
    $[10] = variant;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  let t2;
  if ($[12] !== alt || $[13] !== displayFallback || $[14] !== failedSrc || $[15] !== fallback || $[16] !== src) {
    t2 = src && src !== failedSrc ? <img src={src} alt={alt || "Avatar"} className="h-full w-full rounded-full object-cover" onError={() => setFailedSrc(src)} /> : fallback ? <span>{getInitials(displayFallback)}</span> : <FaUser className="h-1/2 w-1/2" />;
    $[12] = alt;
    $[13] = displayFallback;
    $[14] = failedSrc;
    $[15] = fallback;
    $[16] = src;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  let t3;
  if ($[18] !== forwardedRef || $[19] !== props || $[20] !== t1 || $[21] !== t2) {
    t3 = <div ref={forwardedRef} className={t1} {...props}>{t2}</div>;
    $[18] = forwardedRef;
    $[19] = props;
    $[20] = t1;
    $[21] = t2;
    $[22] = t3;
  } else {
    t3 = $[22];
  }
  return t3;
});
Avatar.displayName = "Avatar";
export default Avatar;
export { avatarVariants, type AvatarProps };
function _temp(n) {
  return n[0];
}
function _temp2(name) {
  return name.split(" ").map(_temp).join("").toUpperCase().slice(0, 2);
}